import { Component, OnInit } from '@angular/core';
import { ForecastSeason } from '../../models/Forecast.model';
import { NotificationsService } from 'angular2-notifications';
import { InterpretationService } from '../../interpretation.service';
import { GETSetupEquipmentService } from '../../../../../app/modules/GET_NEW_UI/setup-equipment/setup-equipment.service';
import { CustomerSelectItem } from '../../../../../app/modules/setup-equipment/setup-equipment.model';
import { GenericIdName } from '../../../../../app/shared/models/common-search-filters.model';
import { JobsiteSelectionFilter } from '../../../../../app/modules/GET_NEW_UI/favourite-dialog/favourite-dialog-modal';
import { FavouriteDialogService } from '../../../../../app/modules/GET_NEW_UI/favourite-dialog/favourite-dialog.service';

@Component({
  selector: 'app-forecast-seasonal-dates',
  templateUrl: './forecast-seasonal-dates.component.html',
  styleUrls: ['./forecast-seasonal-dates.component.scss']
})
export class ForecastSeasonalDatesComponent implements OnInit {
  customerId = 0;
  jobSiteId = 0;
  seasonalDates: ForecastSeason[] = [];
  displayedColumns = [
    'season',
    'startDate',
    'endDate',
    'action'
  ];
  selectedCustomer: number[] = [];
  isLoading = false;
  customerList: CustomerSelectItem[] = [];
  jobsiteList: GenericIdName[] = [];
  loadingJobsite: boolean = false;
  months = Array.from({ length: 12 }, (_, index) => {
    const month = index + 1;
    return {
      id: month,
      name: new Date(2000, index, 1).toLocaleString('default', {
        month: 'short'
      }),
      days: new Date(new Date().getFullYear(), month, 0).getDate()
    };
  });
  constructor(public _favouriteDialogService: FavouriteDialogService,private _notify: NotificationsService,
    private _interp: InterpretationService,
    private _equipmentService: GETSetupEquipmentService,) { }

  ngOnInit(): void {
    this.loadCustomers();
  }
  isLeapYear(year: number): boolean {
    return (year % 4 === 0 && year % 100 !== 0) || (year % 400 === 0);
  }
  loadCustomers() {
    this._equipmentService.getCustomerList().subscribe(r => {
      this.customerList = r;
      if (this.customerList.length == 1) {
        this.loadJobsitesForCustomer();
      }
    });
  }
  loadJobsitesForCustomer() {
    this.loadingJobsite = true;

    this.jobsiteList = null;
    var params: JobsiteSelectionFilter = {
      Customers: [this.customerId],
    }
    this._favouriteDialogService.GetjobsitesAvailable(params).subscribe(r => {
      if (r) {
        this.jobsiteList = r;
        this.loadingJobsite = false;
      }
    });
  }

  loadSeasonalDates() {
    if (!this.customerId || !this.jobSiteId)
      return;
    this.isLoading = true;
    this._interp.getSeasonalDates(this.customerId, this.jobSiteId).subscribe({
        next: (response) => {
          this.seasonalDates = response;
          this.isLoading = false;
        },
        error: () => {
          this.isLoading = false;
          this._notify.error('Error saving data', 'Failed to save the record');
        }
      });
  }

  save() {
    if (!this.validate())
      return;
    this.isLoading = true;
    this._interp.SaveSeasonalDates({ CustomerId: this.customerId, JobSiteId: this.jobSiteId, SeasonalDates: this.seasonalDates }).subscribe({
      next: () => {
        this.isLoading = false;
        this._notify.success('Success', 'Record saved successfully');
      },
      error: () => {
        this.isLoading = false;
        this._notify.error('Error saving data', 'Failed to save the record');
      }
    });
  }

  validate(): boolean {
    // Required & Invalid Date Validation
    for (const item of this.seasonalDates) {
      const isOptional = item.WeatherId === 4;
      if (!isOptional && (!item.StartMonth || !item.StartDay)) {
        this._notify.warn('Warning', `${item.WeatherTypeName} Start Date is required.`);
        return false;
      }
      if (!isOptional && (!item.EndMonth || !item.EndDay)) {
        this._notify.warn('Warning', `${item.WeatherTypeName} End Date is required.`);
        return false;
      }
      if (
        isOptional && !item.StartMonth && !item.StartDay && !item.EndMonth && !item.EndDay) {
        continue;
      }
      const startDate = new Date(2000, item.StartMonth - 1, item.StartDay);
      if (startDate.getMonth() !== item.StartMonth - 1 || startDate.getDate() !== item.StartDay) {
        this._notify.warn('Warning', `${item.WeatherTypeName} Start Date is invalid.`);
        return false;
      }
      const endDate = new Date(2000, item.EndMonth - 1, item.EndDay);
      if (endDate.getMonth() !== item.EndMonth - 1 || endDate.getDate() !== item.EndDay) {
        this._notify.warn('Warning', `${item.WeatherTypeName} End Date is invalid.`);
        return false;
      }
    }
    // Overlap Validation
    for (let i = 0; i < this.seasonalDates.length; i++) {
      const first = this.seasonalDates[i];
      const firstRanges = this.getRanges(first.StartMonth!, first.StartDay!, first.EndMonth!, first.EndDay!);
      for (let j = i + 1; j < this.seasonalDates.length; j++) {
        const second = this.seasonalDates[j];
        const secondRanges = this.getRanges(second.StartMonth!, second.StartDay!, second.EndMonth!, second.EndDay!);

        if (this.isOverlap(firstRanges, secondRanges)) {

          this._notify.warn(
            'Warning',
            `${first.WeatherTypeName} overlaps with ${second.WeatherTypeName}.`
          );

          return false;
        }
      }
    }

    return true;
  }
  private getDayOfYear(month: number, day: number): number {

    const date = new Date(2000, month - 1, day);

    const start = new Date(2000, 0, 1);

    return Math.floor(
      (date.getTime() - start.getTime()) / (1000 * 60 * 60 * 24)
    ) + 1;
  }
  private getRanges(startMonth: number, startDay: number, endMonth: number, endDay: number): { start: number; end: number }[] {
    const start = this.getDayOfYear(startMonth, startDay);
    const end = this.getDayOfYear(endMonth, endDay);

    // Normal season
    if (start <= end)
      return [{ start, end }];

    return [{ start, end: 366 }, { start: 1, end }];
  }
  private isOverlap(first: { start: number; end: number }[], second: { start: number; end: number }[]
  ): boolean {
    for (const a of first) {
      for (const b of second) {
        if (a.start <= b.end && b.start <= a.end) {
          return true;
        }
      }
    }
    return false;
  }

  getDays(month: number): number[] {
    if (!month) {
      return [];
    }
    const currentYear = new Date().getFullYear();
    // Returns 28/29 for Feb depending on leap year
    const daysInMonth = new Date(currentYear, month, 0).getDate();
    return Array.from({ length: daysInMonth }, (_, i) => i + 1);
  }

  resetRow(row: any): void {

  this.isLoading = true;
  this._interp.resetSeasonDate(row.WeatherId, row.CustomerId, row.JobSiteId).subscribe({
    next: () => {
      // Clear UI
      row.StartMonth = null;
      row.StartDay = null;
      row.EndMonth = null;
      row.EndDay = null;
      this._notify.success('Success', 'Season dates have been reset.');
      this.isLoading = false;
    },
    error: () => {
      this._notify.error('Error', 'Failed to reset season dates.');
      this.isLoading = false;
    }
  });
}
}
